// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upgrade-background {
  text-align: center;
  width: 100%;
  padding: 10px;
  background-size: 400px;
  background-repeat: repeat;
  background-position: 0px 0;
  animation: bg-move 5s linear infinite;
}

@keyframes bg-move {
  0% {
    background-position: 0px 0;
  }
  100% {
    background-position: 0px 400px;
  }
}

.upgrade-window {
  animation: show-window 0.2s ease;
}

@keyframes show-window {
  0% {
    transform: translateY(-100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.upgrading-line-bg {
  background-color: rgb(0, 0, 0);
  height: 16px;
  width: 75%;
  border-radius: 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  border: 2px solid black;
}

.upgrading-line {
  background: linear-gradient(0deg, #225e10, #57b90d, #9dfd65);
  height: 12px;
  width: 100%;
  border-radius: 20px;
  transition: transform linear 3s;
}

.upgrade-items {
  position: relative;
  box-shadow: inset 0px 0px 12px 5px rgba(0, 0, 0, 0.5);
  height: 20vw;
  max-width: 90px;
  max-height: 90px;
  aspect-ratio: 1/1;
  background-color: #3d3d3d;
  border-radius: 12px;
  border: 2px solid #ffffff54;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upgrade-items-list {
  position: absolute;
  display: flex;
  gap: 5px;
  bottom: 110%;
  flex-direction: column;
  animation: show-upgrade-items 0.1s ease;
}

@keyframes show-upgrade-items {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.upgrade-buttons {
  font-family: "Press Start 2P", system-ui;
  padding: 16px 24px;
  border-radius: 8px;
  background-color: #fff000;
}

.upgrade-buttons:disabled {
  opacity: 1;
  background-color: #3d3d3d;
}

.upgrade-buttons-container {
  animation: show-buttons 0.2s ease;
}

@keyframes show-buttons {
  0% {
    bottom: -50px;
    opacity: 0;
  }
  100% {
    bottom: 20px;
    opacity: 1;
  }
}

.instruction-wrapper {
  position: absolute;
  z-index: 8;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  left: 0;
  top: 0;
  background-color: #165aece3;
  padding: 12px;
}

.instruction-text {
  padding: 12px;
  width: 90%;
  border-radius: 12px;
}

.info-button {
  position: absolute;
  z-index: 8;
  top: -34px;
  right: 12px;
  border-radius: 8px;
  padding: 8px 8px;
  background-color: #165aec;
  font-family: "Press Start 2P", system-ui;
}
`, "",{"version":3,"sources":["webpack://./src/UpgradeStyles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,MAAM;EACN,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C","sourcesContent":[".upgrade-background {\r\n  text-align: center;\r\n  width: 100%;\r\n  padding: 10px;\r\n  background-size: 400px;\r\n  background-repeat: repeat;\r\n  background-position: 0px 0;\r\n  animation: bg-move 5s linear infinite;\r\n}\r\n\r\n@keyframes bg-move {\r\n  0% {\r\n    background-position: 0px 0;\r\n  }\r\n  100% {\r\n    background-position: 0px 400px;\r\n  }\r\n}\r\n\r\n.upgrade-window {\r\n  animation: show-window 0.2s ease;\r\n}\r\n\r\n@keyframes show-window {\r\n  0% {\r\n    transform: translateY(-100px);\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.upgrading-line-bg {\r\n  background-color: rgb(0, 0, 0);\r\n  height: 16px;\r\n  width: 75%;\r\n  border-radius: 20px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n  border: 2px solid black;\r\n}\r\n\r\n.upgrading-line {\r\n  background: linear-gradient(0deg, #225e10, #57b90d, #9dfd65);\r\n  height: 12px;\r\n  width: 100%;\r\n  border-radius: 20px;\r\n  transition: transform linear 3s;\r\n}\r\n\r\n.upgrade-items {\r\n  position: relative;\r\n  box-shadow: inset 0px 0px 12px 5px rgba(0, 0, 0, 0.5);\r\n  height: 20vw;\r\n  max-width: 90px;\r\n  max-height: 90px;\r\n  aspect-ratio: 1/1;\r\n  background-color: #3d3d3d;\r\n  border-radius: 12px;\r\n  border: 2px solid #ffffff54;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.upgrade-items-list {\r\n  position: absolute;\r\n  display: flex;\r\n  gap: 5px;\r\n  bottom: 110%;\r\n  flex-direction: column;\r\n  animation: show-upgrade-items 0.1s ease;\r\n}\r\n\r\n@keyframes show-upgrade-items {\r\n  0% {\r\n    transform: translateY(30px);\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateY(0px);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.upgrade-buttons {\r\n  font-family: \"Press Start 2P\", system-ui;\r\n  padding: 16px 24px;\r\n  border-radius: 8px;\r\n  background-color: #fff000;\r\n}\r\n\r\n.upgrade-buttons:disabled {\r\n  opacity: 1;\r\n  background-color: #3d3d3d;\r\n}\r\n\r\n.upgrade-buttons-container {\r\n  animation: show-buttons 0.2s ease;\r\n}\r\n\r\n@keyframes show-buttons {\r\n  0% {\r\n    bottom: -50px;\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    bottom: 20px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.instruction-wrapper {\r\n  position: absolute;\r\n  z-index: 8;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 12px;\r\n  left: 0;\r\n  top: 0;\r\n  background-color: #165aece3;\r\n  padding: 12px;\r\n}\r\n\r\n.instruction-text {\r\n  padding: 12px;\r\n  width: 90%;\r\n  border-radius: 12px;\r\n}\r\n\r\n.info-button {\r\n  position: absolute;\r\n  z-index: 8;\r\n  top: -34px;\r\n  right: 12px;\r\n  border-radius: 8px;\r\n  padding: 8px 8px;\r\n  background-color: #165aec;\r\n  font-family: \"Press Start 2P\", system-ui;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
